import { ScriptNames } from '../Project/store';

export const SCROLL_CONTAINER_ID = 'dnd-scroll-container';
export const ENTRIES_PER_PAGE = 35;
export const SCRIPTS_DATE_TO_SHOW = [
  ScriptNames.Automodeler,
  ScriptNames.Prediction,
  ScriptNames.TimeSeriesAutomodeler,
  ScriptNames.TimeSeriesPrediction,
  ScriptNames.TimeSeriesPreprocessor,
];
